import React from 'react';
import {
    COVER_DIM_ON_LIGHT,
    CoverLogo,
    CoverMeta,
    coverTitleSize,
    type CoverTemplateProps,
} from './shared';

export const SoftHeader: React.FC<CoverTemplateProps> = ({ fields, colors, logoUrl, showLogo }) => (
    <div className="flex size-full flex-col">
        <div
            className="flex flex-none flex-col gap-[1.4em] px-[2.2em] pb-[2em] pt-[2.4em] text-white"
            style={{ backgroundColor: colors.primary }}
        >
            <CoverLogo logoUrl={logoUrl} showLogo={showLogo} />
            <div
                className="font-bold leading-[1.05] tracking-[-0.02em]"
                style={{ fontSize: coverTitleSize(1.95) }}
            >
                {fields.document_title}
            </div>
        </div>
        <div className="flex flex-1 flex-col justify-between px-[2.2em] py-[2em]">
            {fields.subtitle ? (
                <div className="text-[0.82em]" style={{ color: COVER_DIM_ON_LIGHT }}>
                    {fields.subtitle}
                </div>
            ) : (
                <div />
            )}
            <CoverMeta fields={fields} />
        </div>
    </div>
);
